(() => {
  const newsletterSuccess = document.querySelector('[data-newsletter-success]');

  if (newsletterSuccess) {
    const successPanel = newsletterSuccess.querySelector('[data-newsletter-success-panel]');
    const successContinueButton = newsletterSuccess.querySelector('[data-newsletter-success-continue]');
    const newsletterInput = document.querySelector('.sv-password__email');
    const returningAccessButton = document.querySelector('.sv-password__subscriber-access');
    const backgroundFrame = document.querySelector('.sv-password__frame');
    let isClosingSuccess = false;

    const resetSuccessScrollPosition = () => {
      const cleanUrl = new URL(window.location.href);
      cleanUrl.hash = '';
      cleanUrl.searchParams.delete('customer_posted');
      document.documentElement.style.scrollBehavior = 'auto';
      window.history.replaceState({}, '', `${cleanUrl.pathname}${cleanUrl.search}`);
      window.scrollTo(0, 0);
      window.requestAnimationFrame(() => {
        window.scrollTo(0, 0);
        document.documentElement.style.scrollBehavior = '';
      });
    };

    try {
      window.localStorage.setItem('svyre-newsletter-returning-v1', '1');
    } catch (error) {
      // The confirmation still works when browser storage is unavailable.
    }

    const dismissNewsletterSuccess = (showThankYouPage = false) => {
      if (isClosingSuccess) return;

      isClosingSuccess = true;
      if (showThankYouPage) {
        document.documentElement.classList.add('svyre-newsletter-returning');
      }
      newsletterSuccess.classList.add('is-closing');

      window.setTimeout(() => {
        newsletterSuccess.hidden = true;
        document.body.classList.remove('sv-password-success-open');
        backgroundFrame?.removeAttribute('inert');
        backgroundFrame?.removeAttribute('aria-hidden');
        document.removeEventListener('keydown', handleSuccessKeydown);
        window.scrollTo(0, 0);
        (showThankYouPage ? returningAccessButton : newsletterInput)?.focus({ preventScroll: true });
      }, 240);
    };

    const handleSuccessKeydown = (event) => {
      if (newsletterSuccess.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        dismissNewsletterSuccess();
        return;
      }

      if (event.key !== 'Tab' || !successPanel) return;

      const focusableElements = successPanel.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );

      if (focusableElements.length === 0) {
        event.preventDefault();
        successPanel.focus();
        return;
      }

      const first = focusableElements[0];
      const last = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && (document.activeElement === first || document.activeElement === successPanel)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    resetSuccessScrollPosition();
    document.body.classList.add('sv-password-success-open');
    backgroundFrame?.setAttribute('inert', '');
    backgroundFrame?.setAttribute('aria-hidden', 'true');
    window.requestAnimationFrame(() => successPanel?.focus());
    successContinueButton?.addEventListener('click', () => dismissNewsletterSuccess(true));
    newsletterSuccess.addEventListener('click', (event) => {
      if (event.target === newsletterSuccess || event.target.closest('.sv-password__success-backdrop')) {
        dismissNewsletterSuccess();
      }
    });
    document.addEventListener('keydown', handleSuccessKeydown);
  }

  const dialog = document.querySelector('[data-password-dialog]');
  const openButtons = document.querySelectorAll('[data-password-open]');

  if (!dialog || openButtons.length === 0) return;

  const panel = dialog.querySelector('.sv-password__dialog-panel');
  const input = dialog.querySelector('[data-password-input]');
  const closeButtons = dialog.querySelectorAll('[data-password-close]');
  let lastActiveElement = null;

  const openDialog = () => {
    lastActiveElement = document.activeElement;
    dialog.hidden = false;
    document.body.classList.add('sv-password-dialog-open');
    window.requestAnimationFrame(() => {
      dialog.classList.add('is-open');
      input?.focus();
    });
  };

  const closeDialog = () => {
    dialog.classList.remove('is-open');
    document.body.classList.remove('sv-password-dialog-open');
    window.setTimeout(() => {
      dialog.hidden = true;
      lastActiveElement?.focus();
    }, 260);
  };

  openButtons.forEach((button) => button.addEventListener('click', openDialog));
  closeButtons.forEach((button) => button.addEventListener('click', closeDialog));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !dialog.hidden) closeDialog();
  });

  if (dialog.querySelector('[data-password-error]')) openDialog();
})();
